import { render } from "./SearchFilter.vue?vue&type=template&id=74067fb3"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"
script.render = render

export default script